import { Skeleton, Stack, Typography } from "@mui/material"
import { useStore } from "@nanostores/react"
import { useMemo } from "react"

import { NumberFont } from "./fonts"
import { $arPrice } from "../../stores/currency-store"
import { $poolsOverviewMap } from "../../stores/pools-store"
import { ConvertedAmountBlock } from "../ConvertedAmountBlock"
import { useAoPrice } from "@/api/portfolio-api"

export function HeaderStatBar() {
  const poolsOverviewMap = useStore($poolsOverviewMap)

  const totalTransactions = useMemo(
    () =>
      poolsOverviewMap === null
        ? null
        : Object.values(poolsOverviewMap).reduce((acc, overview) => {
            if (overview === undefined) return acc

            return acc + overview.transactions
          }, 0),
    [poolsOverviewMap],
  )

  const { data: aoPrice } = useAoPrice()

  const arPrice = useStore($arPrice) || undefined

  const totalVolume = useMemo(
    () =>
      poolsOverviewMap === null || arPrice === undefined
        ? null
        : Object.values(poolsOverviewMap).reduce((acc, overview) => {
            if (overview === undefined) return acc

            return acc + overview.volumeUsd
          }, 0) / arPrice,
    [poolsOverviewMap, arPrice],
  )

  return (
    <Stack
      sx={{
        alignSelf: "flex-start",
        paddingY: 1,
        textTransform: "uppercase",
        paddingX: { xs: 2, sm: 0 },
        "& > *": {
          // minWidth: 70,
          alignItems: { xs: "flex-start", md: "flex-end" },
        },
      }}
      direction="row"
      alignItems="center"
      gap={4}
    >
      <Stack>
        <Typography variant="caption" color="text.secondary">
          {/* {nativeTokenInfo.ticker}: */} AO
        </Typography>
        <Typography fontFamily={NumberFont} fontWeight={700}>
          <ConvertedAmountBlock amount={1} quoteTokenUsdPrice={aoPrice} />
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="caption" color="text.secondary">
          {/* {nativeTokenInfo.ticker}: */} AR
        </Typography>
        <Typography fontFamily={NumberFont} fontWeight={700}>
          <ConvertedAmountBlock amount={1} quoteTokenUsdPrice={arPrice} />
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="caption" color="text.secondary">
          24h Volume
        </Typography>
        {totalVolume === null ? (
          <Skeleton width={80} component="span" sx={{ display: "inline-flex" }} />
        ) : (
          <Typography fontFamily={NumberFont} fontWeight={700}>
            <ConvertedAmountBlock amount={totalVolume} quoteTokenUsdPrice={arPrice} />
          </Typography>
        )}
      </Stack>
      <Stack>
        <Typography variant="caption" color="text.secondary">
          24h Txns
        </Typography>
        {totalTransactions === null ? (
          <Skeleton width={80} component="span" sx={{ display: "inline-flex" }} />
        ) : (
          <Typography fontFamily={NumberFont} fontWeight={700}>
            {totalTransactions}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}
